<template>
    <div>
        <div ref="editor" class="quill-editor"></div>
        <textarea
            v-model="content"
            name="quillContent"
            hidden
        ></textarea>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            quill: null,
            content: this.value,
        };
    },
    watch: {
        content(newContent) {
            this.$emit('input', newContent); // Emit content changes
        },
        value(newValue) {
            if (newValue !== this.content) {
                this.quill.root.innerHTML = newValue;
            }
        },
    },
    mounted() {
        // Initialize Quill
        this.quill = new Quill(this.$refs.editor, {
            theme: 'snow', // Use 'snow' theme
            modules: {
                toolbar: [
                    [{ header: [1, 2, false] }],
                    ['bold', 'italic', 'underline'],
                    // ['link', 'image'],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                ],
            },
        });

        // Set initial content
        this.quill.root.innerHTML = this.content;

        // Update content on text change
        this.quill.on('text-change', () => {
            this.content = this.quill.root.innerHTML;
        });
    },
};
</script>

<style>
.quill-editor {
    height: 300px;
}
</style>

